export const FBCLID = 'fbclid';
export const FUNNEL_COMPLETE_PAYLOAD_CAPI_KEY = 'funnel_complete_payload_capi';
